import {
  Component, Inject,
  Optional,
  ViewEncapsulation,
} from '@angular/core';
import { MfpcBaseFilesComponent } from 'base-form';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'mfpc-files',
  templateUrl: './mfpc-files.component.html',
  styleUrls: ['./mfpc-files.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MfpcFilesComponent extends MfpcBaseFilesComponent {
  constructor(@Inject('apiToken') @Optional() public readonly apiUrl: string) {
    super(apiUrl);
  }
}
